import { Grocery } from './Grocery';

export interface ShoppingListGrocery {
  id: number;
  shopping_list: number;
  grocery: number;
  grocery_details: Grocery;
  quantity: number;
  picked: number;
  created_at?: string;
  updated_at?: string;
  active?: boolean;
  deleted?: boolean;
}

export interface ShoppingListGroceryFormData {
  grocery: string;
  quantity: string;
}

export const emptyShoppingListGroceryFormData: ShoppingListGroceryFormData = {
  grocery: '',
  quantity: '1',
};